import { call, put, takeLatest } from 'redux-saga/effects';
import { api } from '../../services/api';
import { fetchCnpjFailure, fetchCnpjStart, fetchCnpjSuccess, enviarDadosAction, enviarDadosSuccess, verificarPagamentoAction, salvarSituacaoPagamento, enviarAssinaturaTransacaoID, enviarDadosFailure, verificarCupomStart, verificarCupomSuccess, verificarCupomFailure } from '../reducers/utils';

function* fetchCnpjSaga(action) {
    try {
        const form = new FormData();
        form.append('cnpj', action.payload);
        const response = yield call(api.post, '/Utils/ConsultarCNPJ', form);
        yield put(fetchCnpjSuccess(response.data));
    } catch (error) {
        yield put(fetchCnpjFailure(error.toString()));
    }
}

function* enviarDados(action) {
    try {
        const form = action.payload;
        const response = yield call(api.post, '/Assinatura/AssinarV2', form);
        // independente se der sucesso ou erro, contanto que a requisição ocorra, deve guardar os valores e mensagens
        yield put(enviarDadosSuccess(response.data));
    } catch (error) {
        console.log(error);
        yield put(enviarDadosFailure());
    }
}

function* verificarPagamento(action) {
    try {
        const response = yield call(api.post, `/Assinatura/AssinaturaInadimplente?id=${action.payload}`, {
            headers: {
                'ngrok-skip-browser-warning': '',
            },
        });
        yield put(salvarSituacaoPagamento(response.data));
    }
    catch (error) {
        console.log(error);
        yield put(salvarSituacaoPagamento({}));
    }
}

function* enviarAssinaturaTransacaoIDSaga(action) {
    try {
        let form = action.payload.dadosFinais;
        let url
        if (action.payload.tipoPagamento === 'cartao') {
            url = '/AssinaturaTransacao/PagarCartao' // Pagar Cartão
        } else if (action.payload.tipoPagamento === 'pix') {
            url = '/AssinaturaTransacao/GerarQRCodeBoleto' // Pagar PIX
            delete form.assinatura
        } else {
            console.log('Erro tipoPagamento: ', action.payload.tipoPagamento)
        }
        const response = yield call(api.post, url, form);
        // se der sucesso ou erro, contanto que a requisição ocorra, guarda os valores e mensagens
        yield put(enviarDadosSuccess(response.data));
    } catch (error) {
        console.log(error);
        yield put(enviarDadosFailure());
    }
}

function* verificarCupom(action) {
    try {
        const form = new FormData();
        form.append('codigo', action.payload.codigo);

        const response = yield call(
            api.post,
            `/CupomDesconto/ValidarCodigo?planoAssinaturaOpcaoPagamentoID=${action.payload.planoAssinaturaOpcaoPagamentoID}`,
            form
        );

        yield put(verificarCupomSuccess(response.data));
    } catch (error) {
        yield put(verificarCupomFailure(error.message || 'Erro ao validar cupom'));
    }
}

function* utilsSaga() {
    yield takeLatest(fetchCnpjStart.type, fetchCnpjSaga);
    yield takeLatest(enviarDadosAction.type, enviarDados);
    yield takeLatest(verificarPagamentoAction.type, verificarPagamento);
    yield takeLatest(enviarAssinaturaTransacaoID.type, enviarAssinaturaTransacaoIDSaga);
    yield takeLatest(verificarCupomStart.type, verificarCupom);
}

export default utilsSaga;
